// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'activities'

/**
 * Activity Model Interface (auto-generated from Drizzle schema)
 */
export interface ActivityModel {
  id: string
  orgId: string
  workspaceId: string
  userId?: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  entityType: string
  entityId: string
  entityName: string
  action: string
  userName: string
  productId?: string
  changes?: Record<string, unknown>
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "orgId": {
          "type": "string",
          "maxLength": 100
      },
      "workspaceId": {
          "type": "string",
          "maxLength": 100
      },
      "userId": {
          "type": "string",
          "maxLength": 100
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "entityType": {
          "type": "string",
          "maxLength": 50
      },
      "entityId": {
          "type": "string",
          "maxLength": 100
      },
      "entityName": {
          "type": "string",
          "maxLength": 200
      },
      "action": {
          "type": "string",
          "maxLength": 50
      },
      "userName": {
          "type": "string",
          "maxLength": 200
      },
      "productId": {
          "type": "string",
          "maxLength": 100
      },
      "changes": {
          "type": "object"
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      }
  },
  required: [
      "id",
      "orgId",
      "createdAt",
      "updatedAt",
      "entityType",
      "entityId",
      "entityName",
      "action",
      "userName",
      "workspaceId"
  ],
  indexes: [
      [
          "orgId",
          "entityType",
          "entityId"
      ],
      [
          "orgId",
          "createdAt"
      ],
      [
          "orgId",
          "workspaceId",
          "entityType",
          "entityId"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
